import { Chip, withStyles } from "@material-ui/core";

export const EntityStatusChip = withStyles(({ palette }) => ({
  root: {
    backgroundColor: ({ backgroundColor }: { backgroundColor: string }) =>
      backgroundColor,
    color: palette.common.white,
  },
}))(Chip);
